
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FormGroup',
  props: {
    label: {
      type: String,
      default: undefined
    },
    divide: {
      type: Boolean,
      default: true
    },
    bodyClass: {
      type: String,
      default: ''
    },
    bodyWidthClass: {
      type: String,
      default: 'max-w-2xl'
    }
  }
})
